<template>
  <ul class="pt-routes-list">
    <li
      class="pt-routes-list-item"
      v-for="route in routes"
      :key="route.id"
      @click="flyToRoute(route)"
    >
      <div class="pt-routes-icon">
        <r-icon name="bus" :size="12" />
      </div>
      <div class="pt-routes-list-name">
        <r-text>{{ route.name }}</r-text>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: ["routes"],
  methods: {
    flyToRoute(route) {
      this.$emit("fly-to-route", route);
    }
  }
};
</script>

<style lang="scss">
.pt-routes-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -8px;

  &-item {
    display: flex;
    align-items: center;
    border: 1px solid transparent;
    border-radius: var(--border-radius);
    padding: 8px 16px;
    margin-left: 8px;
    background-color: var(--field_bg) !important;
    border-color: var(--field_border) !important;
    cursor: pointer;

    &:hover {
      background-color: var(--accent_primary) !important;
    }
  }

  &-name {
    margin-left: 8px;
  }
}
</style>
